import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import { Link } from "gatsby"
import "./assets/styles/_index.scss"
import GGFXImage from "../GGFX/GGFXImage"
const { ContentModule } = require("@starberry/gatsby-theme-utils/Modules/ContentModule")
const { CTALink } = require("@starberry/gatsby-theme-utils/Modules/CTALinkModule")

const HomeBanner = (props) => {
    const handleClick = (val) => {
        const element = document.querySelector(val);
        if (element) {
            window.scrollTo({
                behavior: 'smooth',
                top:
                    element.getBoundingClientRect().top -
                    document.body.getBoundingClientRect().top,
            })
        }
    }
    return (
        <section className="landing-banner-wrapper">
            {props.images.map((item, index) => {
                var image_name = "page.landing_banner_image.image"
                return (
                    <GGFXImage ImageSrc={item} altText={`${props?.image?.alternativeText ? props?.image?.alternativeText : ""} banner`} imagetransforms={props.imagetransforms} renderer="srcSet" imagename={image_name} strapiID={props?.id} className="img-fluid" />
                )
            })}
            <div className="landing-banner-content-section">
                <Container>
                    <Row className="d-flex align-items-center">
                        <Col xl={6} md={10}>
                            <div className="landing-banner-content">
                                {props?.banner_content ? <ContentModule Content={props.banner_content?.data?.banner_content} /> : ""}

                                {props.cta_1_link || props.cta_2_link ? <ul className="list-inline ctas">
                                    {props.cta_1_title && props.cta_1_link &&
                                        <li className="list-inline-item">
                                            {props.cta_1_link.external_link === "scroll-down" ?
                                                <a href="javascript:;" onClick={() => handleClick('#landing-section')} className="button button-outline"><span>{props.cta_1_title}</span><i className="icon icon-link-arrow"></i></a> :
                                                <CTALink class="button button-primary" link={props.cta_1_link} title={props.cta_1_title} target_window={props.cta_1_link.target_window} />
                                            }
                                        </li>
                                    }
                                    {props.cta_2_title && props.cta_2_link &&
                                        <li className="list-inline-item">
                                            {props.cta_2_link.external_link === "scroll-down" ?
                                                <a href="javascript:;" onClick={() => handleClick('#landing-section')} className="button button-outline"><span>{props.cta_2_title}</span><i className="icon icon-link-arrow"></i></a> :
                                                <CTALink class="button button-outline" link={props.cta_2_link} title={props.cta_2_title} target_window={props.cta_2_link.target_window} />
                                            }
                                        </li>
                                    }
                                </ul> : ''}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </section>
    );
};

export default HomeBanner;
